import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BASE = "flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs";
const PRIMARY = "bg-primary font-semibold text-primary-foreground hover:bg-primary/90";
const OUTLINE = "border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 font-medium text-slate-600 dark:text-slate-300 hover:border-primary/40 hover:text-primary";

/** The KB toolbar button — one look everywhere (KB landing, Articles, Compose). */
export const KbToolbarButton = ({ icon: Icon, primary = false, testid, onClick, children, className = "" }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`${BASE} ${primary ? PRIMARY : OUTLINE} ${className}`}>
    {Icon && <Icon className="h-3.5 w-3.5" />} {children}
  </button>
);

export const KbBackButton = ({ testid = "kb-back-to-kb" }) => {
  const navigate = useNavigate();
  return (
    <KbToolbarButton icon={ArrowLeft} testid={testid} onClick={() => navigate("/kb")}>Back to KB</KbToolbarButton>
  );
};
